import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { basePath } from "../../util/basePath";
import { Button, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { ErrorOutlined, ArrowForward, Password } from "@mui/icons-material";
import "../../components/formInput.css";
import FormInput from "../../components/FormInput";
import logo from "../../assets/logo.png";
import { useFormik } from "formik";
import LoginPage from "../../components/LoginPage";

const ResetPassword = () => {
  const param = useParams();
  // const paramEmail = param.email;
  // const paramToken = param.token;
  const Navigate = useNavigate();

  const [validUrl, setValidUrl] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [isError, setIsError] = useState(null);
  const [feedBackMsg, setFeedbackMsg] = useState(null);

  const [userEmail, setUserEmail] = useState(null);

  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [logType, setLogType] = useState(null);

  useEffect(() => {
    // console.log(param);

    setIsloading(true);
    setIsError(null);
    const verfiyToken = async () => {
      try {
        const { data } = await axios.get(
          `${basePath.url}auth/verify_reset_email_token/${param.token}`
        );

        if (data.message == "success") {
          setIsloading(false);
          setIsError(null);
          setValidUrl(true);
          setUserEmail(data.email);
        } else {
          setIsloading(false);
          setIsError(data.description);
          setValidUrl(false);
        }
      } catch (err) {
        // console.log(err);
        setIsloading(false);
        setIsError(err.message);
        setValidUrl(false);
      }
    };

    verfiyToken();
  }, [param]);

  const initialValuesReset = {
    resetPassword: "",
    confirmPassword: "",
  };

  const onSubmit = async (values, actions) => {
    const data = {
      email: userEmail,
      password: values.resetPassword,
    };

    setIsloading(true);
    setIsError(null);
    try {
      const response = await axios.post(
        `${basePath.url}auth/reset_password_password`,
        data
      );

      if (response.data.message === "success") {
        setFeedbackMsg("Password Reset Successful!.");
        setIsloading(false);
        setIsError(null);
        actions.resetForm();
        //setLogType("login");
      } else {
        setIsloading(false);
        setIsError("Error Encountered while updating password");
        // setLogText(response.data.description);
        setFeedbackMsg("");

        //actions.resetForm();
      }
    } catch (err) {
      setIsError("Error updating password!");
      setIsloading(false);
      setFeedbackMsg("");
      //actions.resetForm();
    }

    actions.resetForm();
  };

  const validate = (values) => {
    const errors = {};
    if (!values.resetPassword) {
      errors.resetPassword = "Required";
    } else if (values.resetPassword.length < 5) {
      errors.resetPassword = "Password must be at least 5 characters";
    } else if (
      // !/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{5,}$/i.test(
      //   values.resetPassword
      // )
      !/[0-9a-z]{6,}/i.test(values.resetPassword)
    ) {
      errors.resetPassword =
        // "Password must contain a mix of lowercase letters, uppercase letters, numbers & symbols";
        "Password must contain at least one letter and one number";
    }

    if (!values.confirmPassword) {
      errors.confirmPassword = "Required";
    } else if (values.resetPassword !== values.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }
    return errors;
  };

  const resetFormik = useFormik({
    initialValues: initialValuesReset,
    onSubmit: onSubmit,
    validate: validate,
  });
  return (
    <div
      className="fullWidthWrapperMain"
      style={{
        backgroundColor: "#fff",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="smallContainer">
        {validUrl ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              // border: "1px solid #ccc",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px 0px rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              style={{
                width: "100%",
                padding: 50,
                // backgroundColor: " rgb(246, 246, 246)",
                backgroundColor: "transparent",
              }}
            >
              <Typography variant="h5" style={{ textAlign: "center" }}>
                <img
                  src={logo}
                  width={"150px"}
                  style={{ objectFit: "scale-down" }}
                />
              </Typography>
              <Typography variant="subtitle1" style={{ textAlign: "center" }}>
                {" "}
                Reset Password
              </Typography>
            </div>
            {
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  padding: "0px",
                  paddingTop: "5px",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    color: "crimson",
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  <p>{isError}</p>
                </Typography>

                {feedBackMsg && (
                  <Typography
                    variant="subtitle1"
                    color={"#2470f4"}
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                    }}
                  >
                    <p>{feedBackMsg}</p>
                  </Typography>
                )}
                {/* <div>{feedback && <p>{feedback}</p>}</div> */}
                <div>
                  {isLoading ? (
                    // <CircularProgress size="large" color="success" />
                    <span>
                      <CircularProgress />
                    </span>
                  ) : null}
                </div>
              </div>
            }
            {feedBackMsg ? (
              <button
                className="button secondary"
                style={{ cursor: "pointer", margin: 20 }}
              >
                <a
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 10,
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    setLogType("login");
                    setOpenLoginDialog((prev) => {
                      return !prev;
                    });
                  }}
                >
                  <span>Proceed to Login</span>{" "}
                  <ArrowForward style={{ color: "black" }} />
                </a>
              </button>
            ) : (
              <form
                onSubmit={resetFormik.handleSubmit}
                className="loginForm"
                style={{
                  padding: "0px",
                }}
              >
                <div style={{ width: "100%", padding: "15px" }}>
                  <div className="formInput">
                    <input
                      placeholder="NEW PASSWORD"
                      className={
                        resetFormik.touched.resetPassword &&
                        resetFormik.errors.resetPassword
                          ? "inputError"
                          : null
                      }
                      autoComplete="false"
                      type="password"
                      id="resetPassword"
                      name="resetPassword"
                      value={resetFormik.values.resetPassword}
                      onChange={resetFormik.handleChange}
                      onBlur={resetFormik.handleBlur}
                    />
                    {resetFormik.touched.resetPassword &&
                    resetFormik.errors.resetPassword ? (
                      <span className="errorSpan">
                        {resetFormik.errors.resetPassword}
                      </span>
                    ) : null}
                  </div>

                  <div className="formInput">
                    <input
                      placeholder="CONFIRM PASSWORD"
                      className={
                        resetFormik.touched.confirmPassword &&
                        resetFormik.errors.confirmPassword
                          ? "inputError"
                          : null
                      }
                      autoComplete="false"
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={resetFormik.values.confirmPassword}
                      onChange={resetFormik.handleChange}
                      onBlur={resetFormik.handleBlur}
                    />
                    {resetFormik.touched.confirmPassword &&
                    resetFormik.errors.confirmPassword ? (
                      <span className="errorSpan">
                        {resetFormik.errors.confirmPassword}
                      </span>
                    ) : null}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      disabled={resetFormik.isSubmitting}
                      className="button secondary"
                      style={{
                        width: "100%",
                        textTransform: "capitalize",
                        fontWeight: 600,
                        marginTop: "20px",
                        marginRight: 0,
                        marginLeft: 0,
                      }}
                      type="submit"
                    >
                      <a
                        style={{
                          display: "block",
                          textAlign: "center",
                          cursor: "pointer",
                          padding: "10px 10px",
                          width: "100%",
                        }}
                      >
                        Reset Password
                      </a>
                    </Button>
                  </div>
                </div>
              </form>
            )}
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <ErrorOutlined style={{ fontSize: 50 }} color="warning" />
            <Typography variant="h5" style={{ textAlign: "center" }}>
              Invalid Verfication Token
            </Typography>
            <button className="button secondary" style={{ cursor: "pointer" }}>
              <a
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 10,
                  fontSize: "14px",
                }}
                onClick={() => {
                  setLogType("login");
                  setOpenLoginDialog((prev) => {
                    return !prev;
                  });
                }}
              >
                <span>Proceed to Login</span>{" "}
                <ArrowForward style={{ color: "white" }} />
              </a>
            </button>
          </div>
        )}
      </div>
      <LoginPage
        openLoginDialog={openLoginDialog}
        setOpenLoginDialog={setOpenLoginDialog}
        logType={logType}
        setLogType={setLogType}
      />
    </div>
  );
};

export default ResetPassword;
